import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogActions from '@mui/material/DialogActions';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import CancelIcon from '@mui/icons-material/Cancel';

/**
 * Optional-note dialog for owner / GM rejecting a pending client request.
 * Requester is notified only when a note is provided.
 */
const RejectClientRequestDialog = ({
  open,
  reason,
  onReasonChange,
  onClose,
  onConfirm,
  loading = false,
  clientName = null,
}) => (
  <Dialog
    open={open}
    onClose={() => {
      if (loading) return;
      onClose?.();
    }}
    aria-labelledby="reject-client-request-dialog-title"
    maxWidth="sm"
    fullWidth
  >
    <DialogTitle id="reject-client-request-dialog-title">
      Reject Client Request
    </DialogTitle>
    <DialogContent>
      <DialogContentText sx={{ mb: 2 }}>
        This permanently removes the client request
        {clientName ? ` for "${clientName}"` : ''}.
        {reason?.trim()
          ? ' The requester will be notified with your note.'
          : ' The requester will not be notified unless you add a note.'}
      </DialogContentText>
      <TextField
        autoFocus
        fullWidth
        multiline
        minRows={3}
        maxRows={6}
        label="Note (optional)"
        inputProps={{ maxLength: 500 }}
        value={reason}
        onChange={(e) => onReasonChange?.(e.target.value)}
        disabled={loading}
        placeholder="Why is this client request being rejected?"
      />
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose} disabled={loading}>
        Cancel
      </Button>
      <Button
        onClick={onConfirm}
        color="error"
        variant="contained"
        disabled={loading}
        startIcon={<CancelIcon />}
      >
        {loading ? 'Rejecting…' : 'Reject Request'}
      </Button>
    </DialogActions>
  </Dialog>
);

export default RejectClientRequestDialog;
